import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ITime } from '../../../model/time';
import TimeDisplayActions from './store/time-display.action-types';
import { TimeDisplayState } from './store/time-display.reducers';
import { timeDisplaySelector } from './store/time-display.selectors';

@Injectable({
    providedIn: 'root'
})
export class TimeDisplayService {
    constructor(private readonly store: Store<TimeDisplayState>) {}

    requestTimeDisplay() {
        this.store.dispatch(TimeDisplayActions.requestTimeDisplay());
    }

    loadTimeDisplay(time: ITime) {
        this.store.dispatch(TimeDisplayActions.loadTimeDisplay({ time }));
    }

    getTimeDisplay(): Observable<ITime> {
        return this.store.select(timeDisplaySelector);
    }
}
